import React from 'react'
import { FormControlLabel, Switch } from '@mui/material'

/**
 * @typedef {import('@mui/material').SwitchProps} MuiSwitchProps
 */

/**
 * @typedef {object} FilterSwitchProps
 * @property {boolean} [disabled] - Si es `true`, el switch estará deshabilitado y no será interactivo.
 * @property {string} label - El texto de la etiqueta que se muestra junto al switch.
 */

/**
 * Un componente simple que renderiza un switch (interruptor) con una etiqueta asociada,
 * diseñado específicamente para ser usado en paneles de filtros.
 * 
 * La etiqueta se posiciona a la izquierda del switch (`labelPlacement="start"`), siguiendo
 * las convenciones de diseño comunes para controles de filtro.
 * 
 * @component
 * @example
 * const MyFilterPanel = () => {
 *   const [isActive, setIsActive] = useState(false);
 * 
 *   const handleToggle = (event) => {
 *     setIsActive(event.target.checked);
 *   };
 * 
 *   return (
 *     <FilterSwitch
 *       label="Solo activos"
 *       checked={isActive}
 *       onChange={handleToggle}
 *     />
 *   );
 * };
 * 
 * @param {FilterSwitchProps & MuiSwitchProps} props - Las props del componente FilterSwitch.
 */
export const FilterSwitch = ({ disabled, label, ...props }) => {
  return (
    <FormControlLabel
      variant="outlined"
      disabled={disabled}
      label={label}
      control={<Switch {...props} />}
      labelPlacement="start"
    />
  )
}

export default FilterSwitch
